(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.CRMSetup",
                {
                    url: "/CRMSetup",
                    component: "crmSetup",
                    resolve: {
                        user: ["currentUser", function (currentUser) {
                            return currentUser;
                        }]
                    },
                    redirectTo: "Home.Settings.CRMSetup.CustomFields"
                });
        }
    ]);

    app.component("crmSetup",
        {
            templateUrl: "/App/Settings/CRMSetup/crm-setup-template.html",
            controller: crmSetupController,
            bindings: {
                user: "<"
            }
        });

    crmSetupController.$inject = [];
    function crmSetupController() { }

})(window.app); // jshint ignore:line